<template>
    <div
        :class="[
            'NotificationsDropdown',
            isModal && 'NotificationsDropdown--modal'
        ]"
    >
        <div
            v-if="reports.length"
            class="NotificationsDropdown__container"
        >
            <div class="NotificationsDropdown__header">
                Reports
            </div>
            <RPReportCard
                v-for="report in reports"
                :key="JSON.stringify(report)"
                class="NotificationsDropdown__card"
                :report="report"
                type="report"
                :card="false"
                @click="$emit('report', report)"
                @download="r => $emit('download', r)"
            />
        </div>
        <div
            v-if="notifications.length"
            class="NotificationsDropdown__container"
        >
            <div class="NotificationsDropdown__header">
                Latest Notifications
            </div>
            <RPNotificationCard
                v-for="(notification, index) in notifications"
                :key="JSON.stringify(notification)"
                :class="cardClass(index)"
                :notification="notification"
                :card="false"
                @click="$emit('notification', notification)"
                @delete="id => $emit('delete-notification', id)"
            />
        </div>
        <div
            class="NotificationsDropdown__button"
        >
            <RPButton
                type="secondary"
                label="See All"
                @click="$emit('notification-page')"
            />
        </div>
    </div>
</template>
<script>
import RPButton from 'components/Basic/Buttons/RPButton.vue';
import RPNotificationCard from 'components/Complex/Notifications/RPNotificationCard.vue';
import RPReportCard from 'components/Complex/Notifications/RPReportCard.vue';
import statusBuilder from 'status/statusBuilder';

export default {
    name: 'NotificationsDropdown',
    components: {
        RPButton,
        RPNotificationCard,
        RPReportCard
    },
    props: {
        reports: {
            type: Array,
            default: () => ([])
        },
        notifications: {
            type: Array,
            default: () => ([])
        },
        isModal: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        cardClass(index){
            return statusBuilder(
                'NotificationsDropdown__card',
                '',
                false,
                {
                    'even': index % 2 === 0
                }
            );
        },
    }
};
</script>
<style lang="scss">
    .NotificationsDropdown {
        border: 1px solid $grey-100;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08);
        background: $white;
        border-radius: 4px;
        width: 19rem;

        &--modal{
            width: 100%;
        }

        &__header {
            padding: 0.5rem;
            font-weight: 600;
            color: $text-dark;
        }

        &__card {
            margin-bottom: 2px;
            &--even {
                background: $grey-50;
            }
        }

        &__button{
            padding: 1rem;
            display: flex;
            align-content: center;
            justify-content: space-around;
        }
    }
</style>
